<template>
  <div class="row" v-loading="true" id="loading"></div>
</template>
<script>
import Vue from 'vue';
import { Loading } from 'element-ui';

Vue.use(Loading.directive);
export default {};
</script>
<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
}

.el-loading-spinner .path {
  /*stroke: #66615b !important;*/
  stroke: #01B0E0 !important;
}

.el-loading-mask {
  /*background: transparent !important;*/
  background: rgba(0, 0, 0, 0.75);
}
.el-icon-loading {font-size: 30px;}
.el-loading-text, .el-loading-spinner i  {color: #01B0E0 !important;}

</style>
